import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Terminal, MessagesSquare } from "lucide-react";
import { ServiceLogTerminal } from "./ServiceLogTerminal";
import { AgenticChatsFeed } from "./AgenticChatsFeed";
import { agenticLogsClient } from "../services/serviceLogsService";

// Agentic tab (PBI 81485): operational Serilog terminal by default, with a "Chats"
// toggle that switches to the anonymized prompt+response feed.

type ViewMode = "logs" | "chats";

export const AgenticLogsTab = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ViewMode>("logs");

  const modeButton = (value: ViewMode, label: string, Icon: typeof Terminal) => (
    <button
      type="button"
      aria-pressed={mode === value}
      onClick={() => setMode(value)}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
        mode === value
          ? "bg-background shadow-sm font-medium"
          : "text-muted-foreground hover:text-foreground"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );

  return (
    <Card className="w-full">
      <CardContent className="pt-6 space-y-4">
        <div className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
          {modeButton("logs", t("logs.modes.logs", "Logs"), Terminal)}
          {modeButton("chats", t("logs.modes.chats", "Chats"), MessagesSquare)}
        </div>

        {mode === "logs" ? (
          <ServiceLogTerminal
            client={agenticLogsClient}
            terminalTitle={t("logs.agenticTerminalTitle", "Terminal de Logs do Agentic")}
          />
        ) : (
          <AgenticChatsFeed />
        )}
      </CardContent>
    </Card>
  );
};
